import Carousel from "components/yenimahalle/Carousel";
import Layout from "components/yenimahalle/Layout";
import Links from "components/yenimahalle/Links";
import MainButtons from "components/yenimahalle/MainButtons";
import Projects from "components/yenimahalle/Projects";
import News from "components/yenimahalle/NewsSlider";
import React, { useEffect, useState } from "react";
import { CustomModal } from "albinasoft-ui-package";
import PortalApi from "api/PortalApi";
import { HomePagePopup } from "models/Response/Portal";
import { useSessionStore } from "store/sessionStorage";

const YenimahalleHome: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [popupData, setPopupData] = useState<HomePagePopup>();

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalApi.getHomePageData();
      const hasSeenPopup = useSessionStore.getState().isPopupOpened;

      if (response && response.popUp && !hasSeenPopup) {
        useSessionStore.getState().setPopupOpened(true);
        setShowModal(true);
        setPopupData(response.popUp);
      } else {
        setShowModal(false);
        setPopupData(null);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <Layout>
        <Carousel />
        <MainButtons />
        <News />
        <Projects />
        <Links />
      </Layout>

      <CustomModal title="" show={showModal} size="lg" onHide={() => setShowModal(false)} footer="" onlyBody={true}>
        {popupData?.hasLink ? (
          <a
            href={popupData?.link}
            target={popupData?.isOpenInNewWindow ? "_blank" : "_self"}
            rel="noopener noreferrer"
          >
            <img src={popupData.imageUrl} alt="Popup Image" style={{ cursor: "pointer" }} />
          </a>
        ) : (
          <img src={popupData?.imageUrl}></img>
        )}
      </CustomModal>
    </>
  );
};

export default YenimahalleHome;
